// extracted by mini-css-extract-plugin
export var dividerContainer = "_7c-0";
export var line = "_7c-1";